import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import React, {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";

function DocsPage(props: {path: string}) {
    const [markdown, setMarkdown] = useState<string>("");
    const springs = useSpring({
        from: { x: 0, opacity: 0 },
        to: { x: 0, opacity: 1 },
    })

    useEffect(() => {
        fetch(props.path)
            .then((res) => res.text())
            .then(setMarkdown)
            .catch(() => setMarkdown("Failed to load md page."));
    }, [props.path]);

    return (
        <animated.div className={'flex-grow'} style={{overflowY: 'scroll', background: '#000', borderRadius: '10px', padding: 'var(--box-padding)', marginBottom: 20, ...springs}}>
            <div className={'flex-grow scroll'} style={{height: 0}}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {markdown}
                </ReactMarkdown>
            </div>
        </animated.div>
    )
}

export default DocsPage;
